module.exports = __webpack_public_path__ + "img/otherasmnt.dae7b70b.svg";